module.exports = __webpack_public_path__ + "img/hc_pro_one_4.c4597892.jpg";